// @flow
/* eslint jsx-a11y/no-static-element-interactions:0 */

import * as React from 'react';
import cx from 'classnames';
import i18n from 'app/common/lib/i18n';
import PropTypes from 'prop-types';
import { dangerouslyFormat } from 'app/common/lib/StringUtil';

// TODO(bca): show loading state
type props = {
  email: string,
  isValid: boolean,
  onClick: () => void,
  showSendEmailText: boolean,
};
export default function SendToEmail({ email, isValid, onClick, showSendEmailText }: props) {
  const icon = isValid ? (
    <div className="icon">{email[0].toUpperCase()}</div>
  ) : (
    <div className={cx('icon', 'typingEmail')}>
      <em />
    </div>
  );

  const subtitleText = isValid ? i18n._('Click to send!') : i18n._('Keep typing!');
  const titleText = showSendEmailText
    ? dangerouslyFormat(i18n._('Email {{ email }}'), { email })
    : dangerouslyFormat(i18n._('Invite {{ email }}'), { email });

  /* eslint-disable jsx-a11y/interactive-supports-focus */
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  return (
    <div className={cx('sendToEmail', { unclickable: !isValid })}>
      <a
        className="selectableEmailItem"
        onClick={() => {
          if (isValid) {
            onClick();
          }
        }}
        role="button"
      >
        <div className="left">{icon}</div>
        <div className="right">
          <h4 className="title">{titleText}</h4>
          <p className="subtitle">{subtitleText}</p>
        </div>
      </a>
    </div>
  );
  /* eslint-enable jsx-a11y/interactive-supports-focus */
  /* eslint-enable jsx-a11y/click-events-have-key-events */
}

SendToEmail.propTypes = {
  email: PropTypes.string.isRequired,
  isValid: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  showSendEmailText: PropTypes.bool.isRequired,
};
